import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { contractDataModel } from "./contractDataModel";
import { ContractDataTable } from "./ContractDataTable";
import { ContractSearchBox } from "./ContractSearchBox";

export const ContractDataBox = () => {

    const { contractExport } = contractDataModel();

    const action = (
        <>
            <div>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={contractExport}
                >导出</Button>
            </div >
        </>
    );

    return (
        <>
            <ContractSearchBox />
            <YhBox title={action} >
                <ContractDataTable />
            </YhBox>
        </>
    )
}
